import { render, staticRenderFns } from "./set-pay.vue?vue&type=template&id=ca6c2d6e&"
import script from "./set-pay.vue?vue&type=script&lang=js&"
export * from "./set-pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports